import { nativeStyles } from '../native/styles/native'
import type WebModel from '../models/WebModel'
import { ADHESION_NATIVE_BODY_CLASS } from '../constants'

const defaultSidebarWidth = 1100
export const adLabelColor = '#a5a5a5'
export const deviceIndicatorPrefix = 'mv-device-'
export const OUTSTREAM_ACTIVE_CLASS = 'mv-adhesion-outstream-active'

export const getBaseStyles = ({
  adhesion_light,
  custom_css,
  recipe_float,
  bidders,
  sidebar_minimum_width
}: WebModel) =>
  `
  :root {
    --adhesion-background-color: ${
      adhesion_light ? `rgba(250, 250, 250, 0.9);` : `rgba(0, 0, 0, 0.9);`
    }
  }

  .mv-empty-wrapper {	
    margin: 0 !important;	
    height: 0px !important;	
    min-height: unset !important;	
  } 
  .adunitwrapper {
    overflow: visible;
    position: relative;
    /* Typical height + padding for adunitlabels */
    height: 264px;
    /* Typical Width */
    width: 300px;
    /* try transition in separate a/b test */
    /* transition: all 0.5s; */
  }

  body .adunitwrapper[style*='display: block']>.adunit:before {
    content: "Loading Ad...";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    -webkit-align-content: center;
    align-content: center;
    justify-content: center;
    font-size: 14px;
    color: #999;
    display: -webkit-box;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    box-sizing: border-box;
  }

  [data-slot] {
    height: 264px;
  }

  [data-hint-slot-inserted="true"] {
    height: revert;
  }

  .mv-outstream-container + .adunit:before { 
    display: none!important;
  }

  .mv-outstream-container + .adunitwrapper>.adunit:before {
    display: none!important;
  }

  body .adunitwrapper[style*='display: block']>.adunit {
    position: relative;
  }

  body .adunitwrapper[style*='display: block']>.adunit>div {
    position: relative;
  }

  .adhesion_wrapper {
    display: none;
    max-height: 90px!important;
  }

  .mv-native-size {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: initial;
    padding-left: 20px;
    overflow: hidden !important;
  }

  .mv-native-size.sidebar_atf_wrapper,
  .mv-native-size.sidebar_btf_wrapper {
    padding-left: 0px;
    padding-bottom: 19px;
  }

  .mv-native-size div[id^='google_ads'] {
    min-height: 100%!important;
    height: 100%!important;
    width: 100%!important;
  }

  .mv-dynamic-size div[id^='google_ads'] {
    height: initial!important;
    width: initial!important;
  }

  mv-ad-reporter {
    display: none;
    position: absolute;
    height: 20px;
    width: 20px;
    z-index: 1200;
    line-height: 1.0;
  }

  .adunitwrapper mv-ad-reporter {
    bottom: 0px;
    right: -22px;
  }
  
  .adunitwrapper.sidebar_atf_wrapper mv-ad-reporter,
  .adunitwrapper.sidebar_btf_wrapper mv-ad-reporter {
    bottom: -20px;
    right: 1px;
  }

  #adhesion_mobile_wrapper mv-ad-reporter,
  #adhesion_desktop_wrapper mv-ad-reporter,
  #adhesion_tablet_wrapper mv-ad-reporter {
    position: relative;
    left: 3px;
  }

  @media (max-width: 391px) {
    .adunitwrapper mv-ad-reporter {
      bottom: -20px;
      right: 1px;
    }
  }

  .adunitwrapper.mv-native-size mv-ad-reporter {
    right: 1px;
    bottom: 0px;
  }

  .mv-ad-box mv-ad-reporter {
    bottom: 1px;
    right: 1px;
  }

  .mv-outstream-container {
    position: absolute;
    z-index:1000;
    height: 100%;
    width: 100%;
  }

  .adhesion_wrapper .mv-outstream-container {
    top: -51px;
    left: 5%;
    width: auto;
  }
  
  .mv-outstream-mute {
    position: absolute;
    top: 5px;
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 999;
  }

  .mv-mute-button, 
  .mv-adhesion-play-button,
  .mv-adhesion-pause-button{
    pointer-events: none;
  }

  .mv-mute-button img {
    width: 32px;
  }

  #arrival_wrapper {
    margin: 10px auto 20px auto!important;
  }

  .mv-arrival-continue-button {
    margin: 0 auto;
    display: block;
    width: 300px;
    text-align: center;
    border-top: 1px solid #efefef;
    padding: 15px 0px;
    z-index: 1001;
  }

  body.adhesion {
    padding-bottom: 90px!important;
  }

  .mediavine img {
    margin : 0 !important;
    padding : 0 !important;
    border : 0 !important;
    box-shadow: none !important;
  }

  .sidebar_btf_wrapper {
    margin : 0 auto 0 auto;
    width : 300px;
  }

  .recipe_mobile_wrapper,
  .content_mobile_wrapper,
  .comments_mobile_wrapper {
    margin-bottom : 10px;
  }

  [data-recipe-ads-inserted] .recipe_btf_wrapper,
  [data-recipe-ads-inserted] .recipe_mobile_wrapper {
    margin: 0 auto;
  }

  .wprm-recipe-ingredients-container .recipe_btf_wrapper{
    float: right;
  }

  .tasty-recipes-ingredients .recipe_btf_wrapper{
    float: right;
  }

  @media (max-width: ${(sidebar_minimum_width || defaultSidebarWidth) - 1}px) {
    #sidebar_btf_sticky_wrapper, .sidebar_btf_wrapper {
      display : none !important;
    }
  }


  .mv-create-target { 
    max-width: 300px !important;
  }

  .adunit a,
  .adunit object,
  .adunit embed,
  .adunit img,
  .adunit div,
  .adunit iframe {
    margin: 0 auto !important;
    text-align: center;
  }

  .content_btf_wrapper.native,
  .content_mobile_wrapper.native {
    max-width : 600px;
  }

  .content_float_right {
    margin : 0 0 10px 20px;
    float : right;
  }

  .content_mobile_wrapper,
  .recipe_mobile_wrapper,
  .comments_mobile_wrapper,
  .comments_btf_wrapper,
  .comments_mobile_wrapper,
  .content_btf_wrapper,
  .feed_mobile_wrapper,
  .feed_btf_wrapper {
    margin : 10px auto 20px auto;
    text-align : center;
  }

  .content_btf_wrapper,
  .content_mobile_wrapper {
    clear: both;
  }

  .leaderboard_atf_wrapper,
  .sidebar_atf_wrapper,
  .leaderboard_btf_wrapper {
    margin : 0px auto 20px auto;
    text-align : center;
  }
  .leaderboard_btf_wrapper {
    margin-top : 20px;
  }

  @media (max-width : 727px) {
    .leaderboard_atf_wrapper {
      display : none !important;
    }
  }

  .adhesion_wrapper.adhesion_container {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    text-align: center;
    width: 100% !important;
    z-index: 2147483535;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: var(--adhesion-background-color, 
      ${adhesion_light ? 'rgba(250, 250, 250, 0.9)' : 'rgba(0, 0, 0, 0.9)'})
  }

  .adhesion_wrapper>.adunit {
    position: sticky;
  }

  .adhesion_wrapper div {
    margin: 0px;
  }

  .gumgumAdhesion .adhesion_wrapper {
    visibility: hidden;
  }

  .adhesion_wrapper .adhesion_buttons {
    height: 80px;
    width: 48px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    margin-left: 3px;
  }

  .adhesion_wrapper .mv_close_button {
    width: 24px;
    height: 24px;
    display: block;
    position: relative;
    cursor: pointer; 
  }

  .adhesion_wrapper .mv_unbutton {
    padding: unset;
    border: unset;
    background-color: transparent;
  }

  .adhesion_wrapper .mv_close_button img {
    width: 24px;
    height: 24px;
    pointer-events: none;
    /* Position it 50% from the top-left corner. */
    position: absolute;
    top: 50%;
    left: 50%;
    /* Then move it back half its width and height for perfect centering. */
    transform: translate(-50%, -50%);
  }

  .universalPlayer_wrapper.uvp_fadeout {
    opacity: 0%;
    transition: all 0.5s linear 3s;
  }

  .universalPlayer_wrapper.uvp_hidden {
    visibility: hidden !important;
  }

  .universalPlayer_wrapper {
    display: block;
    position: fixed;
    background: none;
    box-shadow: rgb(0 0 0 / 15%) 0px 2px 10px;
    z-index: 1100;
    overflow: visible;
    right: 20px;
    bottom: 20px;
    transition: all .3s ease-in;
    transition-delay: 500ms;
  }

  .universalPlayer_wrapper:after {
    content: "\\00B7\\00B7\\00B7";
    position: absolute;
    top: 0px;
    display: flex!important;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    text-align: center;
    color: #C4C4C4;
    font-size: 62px;
    letter-spacing: 2px;
    z-index: 999;
    animation: fadeOut 1s linear 0s infinite;
    animation-direction: alternate;
  }

  .universalPlayer_wrapper .mv-outstream-container {
    border-radius: 10px;
    overflow: hidden;
  }

  .universalPlayer_wrapper .mv-outstream-mute {
    top: unset;
    bottom: 4px;
    left: 30px;
    width: unset;
    opacity: 0.75;
  }

  .universalPlayer_wrapper .mv-outstream-mute:after {
    content: "Ad";
    position: absolute;
    top: 6px;
    color: whitesmoke;
    text-shadow: 0px 0px 8px black;
    font-weight: lighter;
    font-size: 12px;
    width: fit-content;
  }

  .universalPlayer_wrapper .mv-outstream-mute img {
    width: 29px;
  }

  .universalPlayer_wrapper .mv-uvp-menu-backdrop {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;

    flex-direction: row;
    justify-content: center;
    align-items: center;

    background: rgb(0,0,0, 40%);
    border-radius: 10px;
    z-index: 1002;
  }

  .universalPlayer_wrapper .mv-uvp-menu {
    position: absolute;
    z-index: 1003;
    display: flex;
    flex-direction: column;
    width: 55%;
    height: 60%;
    background: white;
    border-radius: 5px;
    align-items: center;
    justify-content: space-around;
    font-weight: 300;
    font-size: 15px;
  }

  .universalPlayer_wrapper .mv-uvp-menu .mv-uvp-menu-item {
    width: 100%;
    height: 100%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;       
  }

  .universalPlayer_wrapper .mv-uvp-menu .mv-uvp-menu-item a {
    text-decoration: none;
    color: inherit;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .universalPlayer_wrapper .mv-uvp-menu .mv-uvp-menu-item a:hover {
    text-decoration: underline;
  }

  .universalPlayer_wrapper .mv-uvp-menu #iconReportSvg {
    margin-right: 3px;
  }

  .universalPlayer_wrapper .mv-uvp-menu .mv-uvp-menu-item:not(:last-child) {
    border-bottom: solid lightgrey 1px;
  }

  .universalPlayer_wrapper .mv-uvp-menu .mv-uvp-menu-item.mv-ad-report-button > * {
    pointer-events: none;
  }

  .universalPlayer_report {
    position: absolute;
    left: 3px;
    bottom: 5px;
    z-index: 1001;
    height: 26px;
    width: 26px;

    display: flex;
    align-items: center;

    background: rgba(30, 30, 30, 0.5);
    border-radius: 15px;
  }

  .universalPlayer_report img {
    opacity: 100%;
    width: 20px;
    height: 20px;
    pointer-events: none;
    margin: 0 auto !important;
  }

  .universalPlayer_close {
    position: absolute;
    top: 7px;
    z-index: 3000;
    padding: 0px 10px;
    line-height: 35px;
    cursor: pointer;
    filter: drop-shadow(0px 0px 6px black);
  }

  .universalPlayer_close img {
    width: 15px;
    height: 15px;
    pointer-events: none;
    margin: 0 auto !important;
  }

  .adunit#universalPlayer {
    background: black;
    border-radius: 10px;
    width: 100%;
    height: 100%;
  }

  .universalPlayer__top {
    top: 0;
  }

  .universalPlayer__bottom {
    bottom: 15px;
  }

  .universalPlayer__right {
    right: 15px;
  }

  .universalPlayer__left {
    left: 15px;
  }

  /* make room for desktop adhesion (90px) */
  body.adhesion .universalPlayer__bottom {
    transform: translateY(-87px);
  }

  /* explicitly supply transform for tablet size (90px) */
  body.adhesion.${deviceIndicatorPrefix}tablet .universalPlayer__bottom {
    transform: translateY(-87px);
  }

  /* make room for mobile adhesion (50px) */
  body.adhesion.${deviceIndicatorPrefix}mobile .universalPlayer__bottom {
    transform: translateY(-47px);
  }

  /* make room for desktop gumgum adhesion (145px) */
  body.adhesion.gumgumAdhesion .universalPlayer__bottom {
    transform: translateY(-142px);
  }

  /* make room for mobile gumgum adhesion (100px) */
  body.adhesion.gumgumAdhesion.${deviceIndicatorPrefix}mobile .universalPlayer__bottom {
    transform: translateY(-97px);
  }

  /* make room for outstream adhesion (100px) */
  body.adhesion.${OUTSTREAM_ACTIVE_CLASS}.${deviceIndicatorPrefix}mobile .universalPlayer__bottom {
    transform: translateY(-97px);
  }

  body.adhesion.${ADHESION_NATIVE_BODY_CLASS}.${deviceIndicatorPrefix}mobile .universalPlayer__bottom {
    transform: translateY(-97px);
  }

  /*Keep Close Button on screen for small devices*/
  @media(min-width: 350px) {
    .adhesion_wrapper .mv_close_small {
      display: none;
    }

  }

  /*Push Logo Up*/
  @media (max-width: 350px) {
    .adhesion_wrapper .mv_unbutton {
      display: none;
    }

    .adhesion_wrapper .adhesion_buttons {
      position: absolute;
      bottom: 51px;
      right: 0px;
      z-index: 11;
      width: 20px;
      height: 20px !important;
    }

    #adhesion_mobile_wrapper mv-ad-reporter {
      display: none !important;
    }
  }

  @media (min-width: 728px) and (max-width: 840px) {
    
  }

  @media (max-width: 727px) {
    body.adhesion {
      padding-bottom : 50px;
    }
    .adhesion_wrapper.adhesion_container {
      justify-content: center;
    }

    /* Provides centered padding for Mediavine logo and Report Button */
    .mv-native-size .adunitlabel {
      max-width: calc(100vw - 15px) !important;
    }
  }

  @media (min-width: 728px) {
    body.adhesion {
      padding-bottom : 90px;
    }
  }

  ${
    // Ensures recipe_float only applies to first
    // recipe slot via styling #recipe_btf_wrapper
    recipe_float
      ? `
  #recipe_btf_wrapper {
    float : right;
  }
  `
      : `
  .recipe_btf_wrapper {
    width : 300px;
    margin : 20px 0 20px 0px !important;
  }`
  }

  @media print {
    .adunit,
    .adunitwrapper,
    .adhesion_wrapper,
    .mv-ad-box, 
    mv-ad-reporter {
      display : none !important;
    }
  }

  #sovrn_beacon {
    position: absolute
  }

  ${
    bidders.find((bidder) => bidder.name === 'triplelift')
      ? `
   .triplelift {
      margin-bottom : 5px !important;
    }

    .triplelift .entry-title {
      background : none !important;
      font-size : 18px;
      line-height : 22px;
      clear : none !important;
    }
    .triplelift .entry-content {
      clear : none !important;
      background : none !important;
    }
    .triplelift .entry-meta {
      display : block !important;
      background : none !important;
      clear : none !important;
      border : none !important;
      float : none !important;
    }
    .triplelift .entry-title a {
      line-height: inherit !important;
      float: none !important;
      width: auto !important;
      height: auto !important;
      background: none !important;
      color: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    `
      : ``
  }

  ${nativeStyles}
  ${custom_css || ''}
`
